import * as types from '../constants'

export const clearCustomer = {
  [types.CLEAR_CUSTOMER_STATE]: ({ draft }) => {
    draft.customer = null
  }
}
